const FacilitiesArrows = () => {
    return (
        <>
            <div className="swiper-button-prev absolute left-0 top-1/2 transform -translate-y-0 z-10 cursor-pointer ml-[0.5rem] ">
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M3.375 8.75H15.5V7.25H3.375L9.075 1.55L8 0.499999L0.499999 8L8 15.5L9.075 14.45L3.375 8.75Z"
                        fill="white"
                    />
                </svg>
            </div>
            <div className="swiper-button-next absolute right-0 top-1/2 transform -translate-y-0 z-10 cursor-pointer mr-[0.5rem]">
                <svg
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M12.625 8.75H0.5V7.25H12.625L6.925 1.55L8 0.499999L15.5 8L8 15.5L6.925 14.45L12.625 8.75Z"
                        fill="white"
                    />
                </svg>
            </div>
        </>
    );
}

export default FacilitiesArrows;